export default __webpack_public_path__ + "3065e3644e5627a151617017af3df133.png";